import React, { Component } from 'react'
import { connect } from 'react-redux'
import styles from '../../../styles/3ds2/main.module.css'
// import CavvPurchaseAppleGoogleSample from '../samples/CavvPurchaseAppleGoogleSample'
import { makeCavvPurchaseRequest } from '../../../actions/threeDSTwoActions'
import { updateOrderId } from '../../../actions/commonActions'
import { _3DS2, _DOTNET, _JAVA, _PHP } from '../../../actions/types'

const OBJECT = [ "cavvPurchase", "cavvPurchase", "$mpgTxn"]

const METHODS = {
    order_id: [ ".SetOrderId(order_id);", ".setOrderId(order_id);", "'order_id'=>$order_id"],
    amount: [ ".SetAmount(amount);", ".setAmount(amount);", "'amount'=>$amount"],
    credit_card_number: [ ".SetPan(pan);", ".setPan(pan);", "'pan'=>$pan"],
    expiry_date: [ ".SetExpdate(expiry_date);", ".setExpDate(expiry_date);", "'expiry_date'=>$expiry_date"],
    CAVV: [ ".SetCavv(cavv);", ".setCavv(cavv);", "cavv=>$cavv"],
    commerce_indicator: [ ".SetCryptType(crypt);", ".setCryptType(crypt);", "'crypt'=>$crypt"],
    _3DS_version: [ ".SetThreeDSVersion(\"3DS_Version\");", ".setThreeDSVersion(\"3DS_Version\");", "'threeds_version'=>$threeds_version"],
    _3DS_server: [ ".SetThreeDSServerTransId(\"3DS_Server_Trans_Id\");", ".setThreeDSServerTransId(\"3DS_Server_Trans_Id\");", "'threeds_server_trans_id'=>$threeds_server_trans_id"],
    network: [ ".SetNetwork(network);", ".setNetwork(network);", ""],
    data_type: [ ".SetDataType(data_type);", ".setDataType(data_type);", ""],
    status_check: [ ".SetStatusCheck(status_check);", ".setStatusCheck(status_check);", "$mpgHttpPost = new mpgHttpsPostStatus($store_id,$api_token,$status,$mpgRequest);"],
    customer_ID: [ ".SetCustId(cust_id);", ".setCustId(cust_id);", "'cust_id'=>$cust_id"],
    dynamic_descriptor: [ ".SetDynamicDescriptor(dynamic_descriptor);", ".setDynamicDescriptor(dynamic_descriptor);", "'dynamic_descriptor'=>$dynamic_descriptor"],
    card_match_ID: [ ".SetCmId(transaction_id);", ".setCmId(transaction_id);", "'cm_id' => $transaction_id"],
    Customer_Information: [ ".SetCustInfo(customer);", ".setCustInfo(customer);", "->setCustInfo($mpgCustInfo);"],
    AVS_Information: [ ".SetAvsInfo(avsCheck);", ".setAvsInfo(avsCheck);", "->setAvsInfo($mpgAvsInfo);"],
    CVD_Information: [ ".SetCvdInfo(cvdCheck);", ".setCvdInfo(cvdCheck);", "->setCvdInfo($mpgCvdInfo);"],
    Convenience_Fee_Information: [ ".SetConvFeeInfo(convFeeInfo);", ".setConvenienceFee(convFeeInfo);", "$mpgConvFee = new mpgConvFeeInfo($convFeeTemplate);"],
    Recurring_Billing: [ ".SetRecur(recurring_cycle);", ".setRecurInfo(recurInfo);", "->setRecur($mpgRecur);"],
    wallet_indicator: [ ".SetWalletIndicator(wallet_indicator);", ".setWalletIndicator(wallet_indicator);", "'wallet_indicator'=>$wallet_indicator"],
    cof: [ ".SetCofInfo(cof);", ".setCofInfo(cof);", "->setCofInfo($cof);"],
    ds_trans_id: [".SetDsTransId(\"DsTransId\");", ".setDsTransId(\"DsTransId\");", "'ds_trans_id' => $ds_trans_id"],

    // cof methods:
    issuer_ID: [ "cof.SetIssuerId(\"VALUE_FOR_ISSUER_ID\");", "cof.setIssuerId(\"VALUE_FOR_ISSUER_ID\");", "$cof->setIssuerId(\"VALUE_FOR_ISSUER_ID\");"],
    payment_indicator: [ "cof.SetPaymentIndicator(\"PAYMENT_INDICATOR_VALUE\");", "cof.setPaymentIndicator(\"PAYMENT_INDICATOR_VALUE\");", "$cof->setPaymentIndicator(\"PAYMENT_INDICATOR_VALUE\");"],
    payment_information: [ "cof.SetPaymentInformation(\"PAYMENT_INFO_VALUE\");", "cof.setPaymentInformation(\"PAYMENT_INFO_VALUE\");", "$cof->setPaymentInformation(\"PAYMENT_INFO_VALUE\");"],
}

class CavvPurchaseAppleGoogle extends Component {
    state = {
        topRef: React.createRef()
    }

    generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }

    getOrderId() {
        const { order_id } = this.props;
        if(order_id === "none")
            return `"Test" + DateTime.Now.ToString("yyyyMMddhhmmss")`;
        else
            return `"${order_id}"`;
    }

    async onCavvPurchasePress() {
        const { cavvPurchaseSuccess, loading } = this.props;
        const { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci } = this.props;

        if(loading || cavvPurchaseSuccess || eci === cavv ) return;

        if(order_id === 'none') {
            const newOrderId = await this.generateOrderId();
            this.props.updateOrderId({ featureId: _3DS2, orderId: newOrderId });
        }
        const cavvPurchaseRequest = { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci };
        this.props.makeCavvPurchaseRequest(cavvPurchaseRequest);
    }

    renderBtn() {
        const { loading, cavvPurchaseSuccess, eci, cavv } = this.props;

        if(!(loading || cavvPurchaseSuccess || eci === cavv)) {
            return (
                <div style={{marginLeft: '20%'}} className={"requestButton"} onClick={() => this.onCavvPurchasePress()}>
                    Cavv Purchase Request
                </div>
            );
        }
        else {
            return (
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'left'}}>
                     <div className="disabledButton">
                        Cavv Purchase Request
                     </div>
                     <i style={{marginLeft: '1vw', fontSize: '0.8rem', color: 'red'}}>* To make this request you need to get cavv and eci (crypt type) by making 3DS Auth request.</i>
                </div>
            );
        }
    }

    renderInteractiveTool() {
        const { leftContents } = styles;

        return (
            <div className={leftContents}>
                <div ref={this.state.topRef} style={{ paddingLeft: '1vw', paddingRight: '2vw', marginBottom: '10%'}}>
                    <h3>Sample Purchase with 3-D Secure – cavvPurchase</h3>
                    {this.renderBtn()}
                </div>
            </div>
        );
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <div ref={this.state.topRef}>
                    <span className="stepPageTitle"><b>Cavv Purchase – Apple Pay and Google Pay™</b></span>
                    
                    <p>The Cavv Purchase for Apple Pay and Google Pay™ transaction follows a 3-D Secure model but it does not require an MPI. Once the transaction payload has been decrypted, this transaction verifies funds on the customer’s card, removes the funds and prepares them for deposit into the merchant’s account.</p>
                    <p>To perform the 3-D Secure authentication, the Moneris MPI or any third-party MPI may be used.</p>
                    <p>In addition to 3-D Secure transactions, this transaction can also be used to process Apple Pay and Google Pay™ transactions. This transaction is applicable only if choosing to integrate directly to Apple Wallet or Google Wallet (if not using the Moneris Apple Pay or Google Pay™ SDKs).</p>
                    <p>Refer to Apple or Google developer portals for details on integrating directly to their wallets to retrieve the payload data.</p>

                    <div className="warning">
                        <p><b>WARNING: </b> Moneris strongly discourages the use of frames as part of a 3-D Secure implementation, and cannot guarantee their reliability when processing transactions in the production environment.</p>
                    </div>

                    <p><b>Cavv Purchase for Apple Pay & Google Pay™ transaction object definition</b></p>
                    {(() => {
                    switch(progLangId) {
                        case _DOTNET:
                            return <code>CavvPurchase cavvPurchase = new CavvPurchase();</code>
                        case _JAVA:
                            return <code>CavvPurchase cavvPurchase = new CavvPurchase();</code>
                        case _PHP:
                            return <code>{"$txnArray = array(‘type’=>’cavvPurchase', …);"}<br />$mpgTxn = new mpgTransaction($txnArray);</code>
                        default:
                            return null
                        }
                    })()}

                    <p style={{ marginTop: '5vh' }}><b>HttpsPostRequest object for Cavv Purchase for Apple Pay & Google Pay™ transaction</b></p>
                    {(() => {
                        switch(progLangId) {
                            case _DOTNET:
                                return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(cavvPurchase);</code>
                            case _JAVA:
                                return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(cavvPurchase);</code>
                            case _PHP:
                                return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);</code>
                            default:
                                return null
                        }
                    })()}

                    <h3 style={{ marginTop: '10vh'}}>Cavv Purchase for Apple Pay & Google Pay™ transaction request fields – Required</h3>
                    <table>
                        <th>Variable Name</th>
                        <th>Type and Limits</th>
                        <th>Set Method</th>

                        <tr>
                            <td>order ID</td>
                            <td><i>String</i><br /><br /> 50-character alphanumeric<br /><br />a-Z A-Z 0-9 _ - : . @ spaces</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.order_id[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>amount</td>
                            <td><i>String</i><br /><br /> 10-character decimal<br /><br />Up to 7 digits (dollars) + decimal point (.) + 2 digits (cents) after the decimal point<br /><br />Example: 1234567.89</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.amount[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>credit card number</td>
                            <td><i>String</i><br /><br /> max 20-character alphanumeric</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.credit_card_number[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>expiry date</td>
                            <td><i>String</i><br /><br /> 4-character alphanumeric<br /><br />YYMM</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.expiry_date[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>Cardholder Authentication Verification Value (CAVV)<br /><br /><p className="note"><b>NOTE: </b> For Apple Pay and Google Pay™ Cavv Purchase and Cavv Pre-Authorization transactions, CAVV field contains the decrypted cryptogram. For more, see Appendix A Definition of Request Fields.</p></td>
                            <td><i>String</i><br /><br /> 50-character alphanumeric</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.CAVV[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>electronic commerce indicator<br /><br /><p className="note"><b>NOTE: </b> For Apple Pay and Google Pay™ Cavv Purchase and Cavv Pre-Authorization transactions, the e-commerce indicator is a mandatory field containing the value received from the decrypted payload or a default value of 5. If you get a 2-character value (e.g.,. 05 or 07) from the payload, remove the initial 0 and just send us the 2nd character. For more, see Appendix A Definition of Request Fields.</p></td>
                            <td><i>String</i><br /><br /> 1-character alphanumeric</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.commerce_indicator[progLangId]}</code></td>
                        </tr>
                    </table>
                    
                    <p style={{ marginTop: '10vh'}}>Following fields are required for Apple Pay and Google Pay only:</p>
                    <table>
                        <th>Variable Name</th>
                        <th>Type and Limits</th>
                        <th>Set Method</th>

                        <tr>
                            <td>network<br /><br /><p className="note"><b>NOTE: </b> This request variable is mandatory for INTERAC® e-Commerce transactions conducted via Apple Pay or Google Pay™ only, and is not for use with credit card transactions.</p></td>
                            <td><i>String</i><br /><br /> alphabetic</td>
                            <td>{progLangId !== _PHP ? <code>{OBJECT[progLangId]}{METHODS.network[progLangId]}</code> : ''}</td>
                        </tr>
                        <tr>
                            <td>data type<br /><br /><p className="note"><b>NOTE: </b> This request variable is mandatory for INTERAC® e-Commerce transactions conducted via Apple Pay or Google Pay™ only, and is not for use with credit card transactions.</p></td>
                            <td><i>String</i><br /><br /> 3-character alphanumeric</td>
                            <td>{progLangId !== _PHP ? <code>{OBJECT[progLangId]}{METHODS.data_type[progLangId]}</code> : ''}</td>
                        </tr>
                    </table>

                    <h3 style={{ marginTop: '10vh'}}>Cavv Purchase for Apple Pay & Google Pay™ transaction request fields – Optional</h3>
                    <table>
                        <th>Variable Name</th>
                        <th>Type and Limits</th>
                        <th>Set Method</th>

                        <tr>
                            <td>status check</td>                        
                            <td><i>Boolean</i><br />true/false</td>
                            <td><code>{progLangId !== _PHP ? 'mpgReq' : ''}{METHODS.status_check[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>customer ID</td>
                            <td><i>String</i><br /><br /> 50-character alphanumeric<br /><p className="note"><strong>NOTE:</strong><br />Some special characters are not allowed:<br />{'< > $ % = ? ^ { } [ ] \\'}</p></td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.customer_ID[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>dynamic descriptor</td>
                            <td><i>String</i><br /><br /> 20-character alphanumeric<br /><br />total of 22 characters including your merchant name and separator<br /><p className="note"><strong>NOTE:</strong><br />Some special characters are not allowed:<br />{'< > $ % = ? ^ { } [ ] \\'}</p></td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.dynamic_descriptor[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>card match ID<br /><p className="note"><b>NOTE: </b> Applies to Offlinx ™ only; must be unique value for each transaction</p></td>
                            <td><i>String</i><br /><br />50-character alphanumeric</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.card_match_ID[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>Customer Information</td>                        
                            <td><i>Object</i><br />N/A</td>
                            <td><code>{OBJECT[progLangId]}{METHODS.Customer_Information[progLangId]}</code></td>
                        </tr>
                    </table>

                    {/* <CavvPurchaseAppleGoogleSample /> */}
                </div>
            </div>
        )
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderInteractiveTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci } = state.threeDSTwo.main.config;
    const { loading, cavvPurchaseSuccess, cavvLookupSuccess } = state.threeDSTwo.main;
    const { mode } = state.common.sideNav;
    const { selection } = state.threeDSTwo.stepsList;
    return { cavvPurchaseSuccess, cavvLookupSuccess, selectedStep: selection, mode, loading, storeId, apiToken, order_id, pan, expdate, amount, cavv, eci, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {makeCavvPurchaseRequest, updateOrderId})(CavvPurchaseAppleGoogle)
